import {isExerciseMatch} from "./isExerciseMatch";
import {getHighlightedTextSegments} from "./highlightSearchText";

export const exerciseRequestSize = 32;

export function debounce(fn, wait) {
    let timer = null;
    const debounced = function () {
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(null, args);
        }, wait);
    };
    debounced.cancel = function () {
        clearTimeout(timer);
        timer = null;
    };
    return debounced;
}

export function getApiUrl(path) {
    const baseUrl = window.apiUrl || "/api/";
    return baseUrl.replace(/\/?$/, "/") + path.replace(/^\//, "");
}

export function buildQuery(params) {
    return Object.keys(params)
        .filter(function (key) {
            return params[key] !== undefined && params[key] !== null && params[key] !== "";
        })
        .map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
        })
        .join("&");
}

export function createCacheKey(path, params) {
    const query = buildQuery(params);
    return path.replace(/^\//, "") + (query ? "?" + query : "");
}

export function getJson(path, params) {
    const query = buildQuery(params);
    const url = getApiUrl(path) + (query ? "?" + query : "");
    return fetch(url, {
        headers: {
            "Accept": "application/json",
        },
        credentials: "same-origin",
    }).then(function (response) {
        if (!response.ok) {
            throw new Error("Could not load exercises");
        }
        return response.json();
    });
}

export function findPrefillResponse(url) {
    const prefill = window.prefill || [];
    for (let i = 0; i < prefill.length; i++) {
        if (prefill[i].request && prefill[i].request.url === url) {
            return prefill[i].response || null;
        }
    }
    return null;
}

export function readOptionLabels(select) {
    const labels = {};
    if (!select) {
        return labels;
    }
    for (let i = 0; i < select.options.length; i++) {
        const option = select.options[i];
        labels[option.value] = option.textContent;
    }
    return labels;
}

export function toggleLoading(control, isLoading) {
    if (control) {
        control.classList.toggle("is-loading", isLoading);
    }
}

export function appendHighlightedText(parent, text, query) {
    const segments = getHighlightedTextSegments(text || "", query || "");

    for (let i = 0; i < segments.length; i++) {
        if (segments[i].highlighted) {
            const mark = document.createElement("mark");
            mark.textContent = segments[i].text;
            parent.appendChild(mark);
        } else {
            parent.appendChild(document.createTextNode(segments[i].text));
        }
    }
}

export function track(eventName, eventCategory, eventLabel) {
    if (typeof window.gtag === "function") {
        window.gtag("event", eventName, {
            "event_category": eventCategory,
            "event_label": eventLabel,
        });
    }
}

export function hasFoundExercise(exercise, searchText) {
    return isExerciseMatch(searchText, exercise.name || "");
}

export function getFirstFoundAlias(exercise, searchText) {
    const aliases = Array.isArray(exercise.aliases) ? exercise.aliases : [];
    for (let i = 0; i < aliases.length; i++) {
        if (isExerciseMatch(searchText, aliases[i])) {
            return aliases[i];
        }
    }
    return null;
}

export function hasFoundAlias(exercise, searchText) {
    return getFirstFoundAlias(exercise, searchText) !== null;
}

export function filterExercises(exercises, category, bodypart, searchText) {
    let filteredExercises = exercises || [];
    if (category !== "") {
        filteredExercises = filteredExercises.filter(function (exercise) {
            return exercise.category === category;
        });
    }
    if (bodypart !== "") {
        filteredExercises = filteredExercises.filter(function (exercise) {
            return exercise.bodypart === bodypart;
        });
    }
    if (searchText !== "") {
        filteredExercises = filteredExercises.filter(function (exercise) {
            return hasFoundExercise(exercise, searchText) || hasFoundAlias(exercise, searchText);
        });
    }
    return filteredExercises;
}
